var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigureflexibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 25.4923 23.9414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 23.9414,
    opacity: 0,
    width: 25.4923,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.17386 5.12109C8.59183 5.12109 9.72855 3.97266 9.72855 2.54297C9.72855 1.13672 8.59183 0 7.17386 0C5.76761 0 4.60746 1.13672 4.60746 2.54297C4.60746 3.97266 5.76761 5.12109 7.17386 5.12109ZM24.5059 21.457L16.7832 17.2852L12.3184 14.1797C11.9903 13.957 11.6739 13.6641 11.4161 13.3359C11.8731 13.0547 12.0606 12.5391 11.9317 12.0352L11.0528 8.47266C10.7364 7.21875 9.59964 6.35156 8.31058 6.35156L5.52152 6.35156C4.66605 6.35156 4.06839 6.5625 3.51761 7.11328L0.341832 10.2891C-0.044887 10.6758-0.103481 11.2734 0.166051 11.7422L2.39261 15.6445L2.39261 22.5117C2.39261 23.1562 2.93168 23.707 3.58793 23.707C4.24418 23.707 4.78324 23.1562 4.78324 22.5117L4.78324 16.6172L11.6153 17.1094L15.752 19.4531L23.3809 23.5547C24.084 23.9297 24.7637 23.5781 25.0098 23.0859C25.3028 22.5 25.0801 21.7617 24.5059 21.457ZM2.6973 11.3438L4.7598 9.26953L6.36527 13.4062L5.09964 14.1328L4.29105 14.1328Z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigureflexibility);
export default __webpack_public_path__ + "static/media/figure.flexibility.13fc3557f540175db19bb4f4c95caf19.svg";
export { ForwardRef as ReactComponent };